import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { t } from '@xingternal/content-helpers';
import EmptyState from '@xingternal/content-empty-state';

import Error503 from './error-503.svg';
import Error404 from './error-404.svg';
import styles from './ErrorGlobal.css';

const getEmptyStateProps = ({ intl, type }) => {
  switch (type) {
    case '503': {
      return {
        title: t(intl, 'CONTENT_ERROR_503_HEADLINE'),
        subtitle: t(intl, 'CONTENT_ERROR_503_SUBLINE'),
        icon: Error503,
      };
    }
    case '404': {
      return {
        title: t(intl, 'CONTENT_ERROR_404_HEADLINE'),
        subtitle: t(intl, 'CONTENT_ERROR_404_SUBLINE'),
        icon: Error404,
        secondaryButton: {
          children: t(intl, 'CONTENT_ERROR_404_BUTTON'),
          href: 'https://www.xing.de',
        },
      };
    }
  }
};

const ErrorGlobal = ({ intl, type }) => (
  <section className={styles.errorContainer}>
    <EmptyState {...getEmptyStateProps({ intl, type })} />
  </section>
);

ErrorGlobal.propTypes = {
  type: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

ErrorGlobal.defaultProps = {
  type: '503',
};

export default injectIntl(ErrorGlobal);
